var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    preserveAspectRatio: "XMaxYMax",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.294 51.116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.097,12.089H9.197A9.20773,9.20773,0,0,0,0,21.286V54.008a9.20773,9.20773,0,0,0,9.197,9.197h56.9a9.20773,9.20773,0,0,0,9.197-9.197V21.287A9.20666,9.20666,0,0,0,66.097,12.089Zm-4.494,6L37.647,33.523,13.691,18.089Zm4.494,39.117H9.197A3.201,3.201,0,0,1,6,54.009V21.457l29.796,19.16c.04.025.083.042.124.065.043.024.087.047.131.069a3.45531,3.45531,0,0,0,.712.278c.025.007.05.01.075.016a3.51927,3.51927,0,0,0,.807.102h.006a3.465,3.465,0,0,0,.807-.102c.025-.006.05-.009.075-.016a3.47749,3.47749,0,0,0,.712-.278c.044-.022.088-.045.131-.069.041-.023.084-.04.124-.065l29.796-19.16V54.008A3.20363,3.20363,0,0,1,66.097,57.206Z",
    transform: "translate(0 -12.089)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIc);
export default __webpack_public_path__ + "static/media/mail-ic.53d67339b3e7bfede87db6817495407f.svg";
export { ForwardRef as ReactComponent };